import { createContext, useContext } from 'react';

import type { DocsContextValue } from './types';

export const DocsContext = createContext<DocsContextValue | undefined>(undefined);

export const useDocs = (): DocsContextValue => {
  const ctx = useContext(DocsContext);
  if (!ctx) {
    throw new Error('useDocs must be used within a DocsProvider');
  }
  return ctx;
};
